import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import apiClient from "../apiClient";
import { Link } from "react-router-dom";



const Currencies = () => {
    const [currencies, setCurrencies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect (() => {
        const fetchAllCurrencies = async () => {
            try {
                const res = await apiClient.get("/currencies");
                setCurrencies(res.data);
            } catch (err) {
                setError("Failed to load currencies.");
            } finally {
                setLoading(false);
            }
        };
        fetchAllCurrencies();
    }, []);

    const handleDelete = async (CurrencyId) => {
        try {
          await apiClient.delete(`/currencies/${CurrencyId}`);
          setCurrencies((prev) => prev.filter((item) => item.CurrencyID !== CurrencyId && item.CurrencyId !== CurrencyId));
        } catch (err) {
          setError("Delete failed. Please try again.");
        }
      };

    return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Currencies</h1>
          <p className="page-subtitle"><Link to="/">Home</Link> / Currencies</p>
        </div>
        <Link className="btn-link" to="/CurrencyAdd">Add Currency</Link>
      </header>

      {error && <p className="notice notice-error">{error}</p>}
      {loading && <p className="notice notice-muted">Loading currencies...</p>}

      {!loading && (
        <section className="resource-list">
          {currencies.length === 0 ? (
            <p className="notice notice-muted">No currencies yet.</p>
          ) : (
            currencies.map((currency) => (
              <article key={currency.CurrencyId || currency.CurrencyID} className="resource-row">
                <div>
                  <strong>{currency.Description}</strong>
                  <div className="resource-meta">{Number(currency.IsDefault) ? "Default currency" : "Secondary currency"}</div>
                  <div className="resource-meta">Exchange rate to default: {Number(currency.ExchangeRateToDefault || 1).toFixed(6)}</div>
                </div>
                <div className="actions">
                  <button className="btn btn-danger" onClick={() => handleDelete(currency.CurrencyId || currency.CurrencyID)}>Delete</button>
                  <Link className="btn-link" to={`/CurrenciesUpdate/${currency.CurrencyId || currency.CurrencyID}`}>Update</Link>
                </div>
              </article>
            ))
          )}
        </section>
      )}
    </div>
    );
};

export default Currencies;
